import type { IIconProps, TBadgeVariant } from '@ad-lucy/ui';
import { Badge, Text } from '@ad-lucy/ui';
import type { keyframes } from 'styled-components';
import { EllipsisText, LinkIcon, StyledDot, StyledLink } from './components';
import type { StyledDotProps } from './types';

type Keyframes = ReturnType<typeof keyframes>;
export type NavBarLinkProps = {
  icon?: IIconProps['type'];
  badge?: {
    loading: boolean;
    value?: number | string | null;
    variant?: TBadgeVariant;
  };
  dot?: StyledDotProps;
  text: string;
  to: string;
  active: boolean;
  collapsed?: boolean;
  animation?: Keyframes;
};

export default function NavBarLink({
  icon,
  text,
  to,
  badge,
  dot,
  active,
  collapsed,
  animation,
}: Readonly<NavBarLinkProps>) {
  return (
    <StyledLink
      to={to}
      $active={active}
      variant={dot?.variant}
      $collapsed={collapsed}
      text={text}
      title={text}
    >
      {dot && <StyledDot {...dot} />}
      {/* Warning: changing the size of the icon directly affects the sidebar animation */}
      {icon && (
        <LinkIcon
          type={icon}
          size={collapsed ? 'md' : 'lg'}
          $animation={animation}
        />
      )}
      {!collapsed && (
        <Text color="currentColor" size="md" weight="medium" as={EllipsisText}>
          {text}
        </Text>
      )}
      {badge && (
        <Badge variant={badge.variant ?? 'archived'}>
          {badge.loading ? '?' : badge.value}
        </Badge>
      )}
    </StyledLink>
  );
}
